// Meeting times as the server reads them: a datetime-local value ("2026-10-05T10:00") is a
// wall-clock time in the meeting's Time zone box, never the browser's or the server's zone.

export const browserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
};

const isValidTimeZone = (timeZone) => {
  if (!timeZone) return false;
  try {
    new Intl.DateTimeFormat("en-US", { timeZone });
    return true;
  } catch {
    return false;
  }
};

// <input type="datetime-local"> value for an instant, written out in `timeZone`. Prefilling the
// reschedule box this way means saving it unchanged sends back exactly the stored time.
export function toZonedDateTimeLocal(value, timeZone) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const zone = isValidTimeZone(timeZone) ? timeZone : browserTimeZone();
  const parts = {};
  new Intl.DateTimeFormat("en-US", {
    timeZone: zone,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  })
    .formatToParts(date)
    .forEach((p) => {
      parts[p.type] = p.value;
    });
  const hour = parts.hour === "24" ? "00" : parts.hour;
  return `${parts.year}-${parts.month}-${parts.day}T${hour}:${parts.minute}`;
}

// "5 Oct 2026, 10:00" in the meeting's own zone (the zone is shown next to it).
export function formatMeetingTime(value, timeZone) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const zone = isValidTimeZone(timeZone) ? timeZone : browserTimeZone();
  return date.toLocaleString("en-GB", {
    timeZone: zone,
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
